import { render, staticRenderFns } from "./AssignJobDialog.vue?vue&type=template&id=4061a1c6&scoped=true"
import script from "./AssignJobDialog.vue?vue&type=script&lang=js"
export * from "./AssignJobDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061a1c6",
  null
  
)

export default component.exports